const HEIGHT_TOP_HEADER = 36; // px
export default HEIGHT_TOP_HEADER;